import { render, staticRenderFns } from "./Classworkshow.vue?vue&type=template&id=db7a4262&scoped=true"
import script from "./Classworkshow.vue?vue&type=script&lang=js"
export * from "./Classworkshow.vue?vue&type=script&lang=js"
import style0 from "./Classworkshow.vue?vue&type=style&index=0&id=db7a4262&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7a4262",
  null
  
)

export default component.exports